import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import Tooltip from '@mui/material/Tooltip';

const RenderRow = ({impact, contribution, catalyzed, total, minified}) => {
  return <TableRow minified={minified}>
    <div>
      <span style={{textTransform: 'capitalize'}}>{impact}</span>
    </div>
    <div>
      <span>{contribution ? `${numeral(contribution).format(0, 0)}` : 0 }</span>
    </div>
    <div>
      <span>{catalyzed ? `${numeral(catalyzed).format(0, 0)}` : 0 }</span>
    </div>
    <div>
      <span>{total ? `${numeral(total).format(0, 0)}` : 0 }</span>
    </div>
  </TableRow>;
};

export const IrDonorClaim = ({ data, minified = false }) => {
  return <Container>
    <Table minified={minified}>
      <Heading minified={minified}>
        <h2>Donor's Claim</h2>
        <Tooltip
          title={
            'Contribution Claim: The portion of a program\'s social impact a donor can claim, equivalent to the percentage of the ' +
            'program they funded or otherwise supported.\n' +
            'Catalyzed Claim: Catalytic impacts are social-impact ripple effects that you can claim beyond those you directly funded.\n' +
            'More detail: What do some of the terms I see in nonprofit Impact Receipts and our Funder Analysis mean?'
          }
        >
          <span>?</span>
        </Tooltip>
      </Heading>
      <TableHeader>
        <div><span>Impact</span></div>
        <div><span>Contribution {!minified && 'Claim'}</span></div>
        <div><span>Catalytic {!minified && 'Claim'}</span></div>
        <div><span>Total</span></div>
      </TableHeader>
      { data.map(row => <RenderRow {...row} minified={minified}/>)}
    </Table>
  </Container>;
};

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const Table = styled.div`
  width: 100%;
  height: auto;
  min-height: 200px;
  background-color: #FFFFFF;
  border: ${({minified}) => minified ? 'none' : 'solid 1px #ccd7e3'};
  border-radius: 4px;
  padding-bottom: 20px; 
`;

const Heading = styled.div`
  position: relative;
  padding: ${({minified}) => minified ? '0px' : '20px'};
  h2 {
    color: #595959;
    font-size: ${({minified}) => minified ? '18px' : '24px'};
    font-weight: 700;
  }
  span {
    width: 30px;
    height: 30px;
    background-color: #ebf0f6;
    border-radius: 15px;
    text-align: center;
    box-sizing: border-box;
    padding-top: 3px;
    cursor: pointer;
    position: absolute;
    top: ${({minified}) => minified ? '0px' : '20px'};
    right: 20px;
    float: right;
    color: #0073a3;
    font-weight: bold;
  }
`;

const TableHeader = styled.div`
  width: 100%;
  height: auto;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  div {
    border-left: 1px solid #ccd7e3;
    padding-left: 5px;
    span {
      font-size: 16px;
      color: #46586b;
      font-weight: 700;
    }
  }
  div:nth-child(1) {
    flex: 1;
    border-left: none;
  }
  div:nth-child(2) {
    flex: 1;
  }
  div:nth-child(3) {
    flex: 1;
  }
  div:nth-child(4) {
    flex: 1;
  }
`;

const TableRow = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: #f5f8fa;
  border-top: solid 1px #ccd7e3;
  border-left: ${({minified}) => minified ? 'solid 1px #ccd7e3' : 'none'};
  border-right: ${({minified}) => minified ? 'solid 1px #ccd7e3' : 'none'};
  display: flex;
  flex-direction: row;
  div {
    padding-right: 10px;
    box-sizing: border-box;
    span {
      font-size: 16px;
      font-weight: 400;
    }
  }
  div:nth-child(1) {
    flex: 1;
    span {
      font-size: 16px;
      color: #46586b;
      font-weight: 700;
    }
  }
  div:nth-child(2) {
    flex: 1;
  }
  div:nth-child(3) {
    flex: 1;
  }
  div:nth-child(4) {
    flex: 1;
    span {
      font-size: 16px;
      color: #46586b;
      font-weight: 700;
    }
  }
  &:last-of-type {
    border-bottom: solid 1px #ccd7e3;
  }
`;